<template>
  <form-box title="基本信息">
    <el-form
      ref="baseInfoForm"
      class="form-box"
      size="medium"
      label-position="top"
      :model="baseInfoForm"
      :rules="rules"
    >
      <div class="form-row">
        <!-- 左侧表单 -->
        <div class="form-column">
          <el-form-item label="企业类型" prop="companyOneType">
            <el-select
              class="companyTypeSelect"
              :disabled="type === 'check'"
              v-model="baseInfoForm.companyOneType"
              placeholder="请选择企业类型"
              @change="changeCompanyOneType"
            >
              <el-option
                v-for="item in allSelectData.companyTypeArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
            <span class="span-gap"></span>
            <el-select
              v-if="subCompanyTypeArr && subCompanyTypeArr.length"
              class="companyTypeSelect"
              :disabled="type === 'check'"
              v-model="baseInfoForm.companyTowType"
              placeholder="请选择企业类型"
            >
              <el-option
                v-for="item in subCompanyTypeArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成员人数" prop="memberNum">
            <el-input
              v-model="baseInfoForm.memberNum"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="5"
              placeholder="请输入成员人数"
            ></el-input>
          </el-form-item>
          <el-form-item label="经营场所类型" prop="premisesType">
            <el-select
              :disabled="type === 'check'"
              v-model="baseInfoForm.premisesType"
              placeholder="请选择经营场所类型"
            >
              <el-option
                v-for="item in allSelectData.premisesTypeArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工作年限" prop="workYears">
            <el-input
              v-model="baseInfoForm.workYears"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="2"
              placeholder="请输入工作年限"
            >
              <template slot="append">年</template>
            </el-input>
          </el-form-item>
          <el-form-item label="债务金额" prop="debtAmount">
            <el-input
              v-model="baseInfoForm.debtAmount"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="10"
              placeholder="请输入债务金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
        <!-- 右侧表单 -->
        <div class="form-column">
          <el-form-item label="企业评定级别" prop="companyLevel">
            <el-select
              :disabled="type === 'check'"
              v-model="baseInfoForm.companyLevel"
              placeholder="请选择企业评定级别"
            >
              <el-option
                v-for="item in allSelectData.companyLevelArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="理事会人数" prop="boardNum">
            <el-input
              v-model="baseInfoForm.boardNum"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="5"
              placeholder="请输入理事会人数"
            ></el-input>
          </el-form-item>
          <el-form-item label="村内任职" prop="villagePosts">
            <el-select
              :disabled="type === 'check'"
              multiple
              v-model="baseInfoForm.villagePosts"
              placeholder="请选择职务"
            >
              <el-option
                v-for="item in allSelectData.villagePostsArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="债务类型" prop="debtType">
            <el-select
              :disabled="type === 'check'"
              v-model="baseInfoForm.debtType"
              placeholder="请选择债务类型"
            >
              <el-option
                v-for="item in allSelectData.debtTypeArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
export default {
  name: "BasicInfo",
  components: {
    FormBox,
  },
  props: {
    baseInfoForm: {
      type: Object,
      default() {
        return {};
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateInteger = (rule, value, callback) => {
      if (!/^[1-9]\d*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    const validateNumAndEmpty = (rule, value, callback) => {
      const pattern = /^\d{0,10}(\.\d{0,2})?$/g;
      if (value && !pattern.test(value)) {
        callback(
          new Error(`${rule.message}必须为数字（整数或保留两位小数）或者空`)
        );
      } else {
        callback();
      }
    };
    return {
      subCompanyTypeArr: [],
      rules: {
        companyOneType: [
          { required: true, message: "请选择企业类型", trigger: "change" },
        ],
        companyLevel: [
          { required: true, message: "请选择企业评定级别", trigger: "change" },
        ],
        memberNum: [
          { required: true, message: "请输入成员人数", trigger: "blur" },
          {
            validator: validateInteger,
            trigger: "blur",
          },
        ],
        boardNum: [
          { required: true, message: "请输入理事会人数", trigger: "blur" },
          {
            validator: validateInteger,
            trigger: "blur",
          },
        ],
        villagePosts: [
          { required: true, message: "请选择职务", trigger: "change" },
        ],
        premisesType: [
          { required: true, message: "请选择经营场所类型", trigger: "change" },
        ],
        debtType: [
          { required: true, message: "请选择债务类型", trigger: "change" },
        ],
        workYears: [
          { required: true, message: "请输入工作年限", trigger: "blur" },
          {
            validator: validateInteger,
            trigger: "blur",
          },
        ],
        debtAmount: [
          { required: true, message: "请输入债务金额", trigger: "blur" },
          {
            validator: validateNumAndEmpty,
            message: "债务金额必须为数字（整数或保留两位小数）",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  watch: {
    allSelectData: {
      deep: true,
      handler() {
        // 一级企业类型选中，自动匹配二级企业类型
        this.getCompanyTwoTypeArr(this.baseInfoForm.companyOneType);
      },
    },
    baseInfoForm: {
      deep: true,
      handler(val) {
        // 一级企业类型选中，自动匹配二级企业类型
        this.getCompanyTwoTypeArr(val.companyOneType);
      },
    },
  },
  methods: {
    // 一级企业类型切换
    changeCompanyOneType(key) {
      this.$emit("changeCompanyOneType");
      this.getCompanyTwoTypeArr(key);
    },
    getCompanyTwoTypeArr(key) {
      if (key) {
        this.allSelectData.companyTypeArr.map((item) => {
          if (item.key === key) {
            this.subCompanyTypeArr = item.pairs;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-box {
  .form-row {
    display: flex;
    background: #f7f9fb;
    .form-column {
      padding: 40px 0 30px 100px;
      flex: 1;
      .el-select.companyTypeSelect {
        width: 178px;
      }
      .span-gap {
        display: inline-block;
        width: 18px;
      }
      ::v-deep .el-form-item__label {
        line-height: normal !important;
      }
      .ipt,
      .el-select {
        width: 374px;
      }
    }
  }
}
</style>
